export default __webpack_public_path__ + "assets/img/ov-logo.a5b5937271f7e88f3eb57de2a777ddfa.svg";